<template>
  <v-card class="py-4">
    <div class="history-title">
      <span>Histórico do produto</span>
    </div>

    <v-timeline dense>
      <v-timeline-item v-for="(log, i) in logs" :key="i" color="normalred">
        <span class="date">{{ formatDate(log.changeDate) }} - </span>
        <span class="description">Estoque para {{ log.newQuantity }},</span>
        <!--<span class="description ml-2">Estoque mínimo para {{ log.newMinimumStock }}</span>-->
      </v-timeline-item>
    </v-timeline>
  </v-card>
</template>

<style scoped>
.history-title {
  font-weight: normal;
  font-size: 18px;
  line-height: 27px;

  text-align: center;

  color: #000000;
}

.date {
  font-weight: normal;
  font-size: 18px;
  line-height: 27px;
  text-align: center;

  color: #9c9c9c;
}

.description {
  font-weight: normal;
  font-size: 18px;
  line-height: 27px;

  color: #000000;
}
</style>

<script>
import moment from "moment";

export default {
  name: "HistoryModal",

  props: {
    logs: Array,
  },

  methods: {
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm:ss");
    },
  },
};
</script>

<style>
</style>
